import React from 'react'
import { useTranslation } from 'react-i18next'
import { SectionShell } from '../shared/SectionShell'
import { SectionHeading } from '../shared/SectionHeading'
import { MetricOdometer } from '../shared/MetricOdometer'
import { useScrollProgressValue } from '../../hooks/useScrollProgressValue'
import metrics from '../../data/metrics.js'

export default function MetricsSection() {
    const { t } = useTranslation()
    const p = useScrollProgressValue('metrics')

    return (
        <SectionShell id="metrics" className="metrics-section">
            <SectionHeading label={t('metrics.label')} />
            <div className="metrics-grid">
                {metrics.map((m) => {
                    const isCoffee = m.value === Infinity
                    return (
                        <div key={m.id} className="metrics-cell">
                            <div className="metrics-value">
                                {isCoffee ? (
                                    <span className="metric-odometer">∞</span>
                                ) : (
                                    <MetricOdometer
                                        target={m.value}
                                        progress={p}
                                        fmt="plus"
                                    />
                                )}
                            </div>
                            <p className="metrics-label">{t(m.tKey)}</p>
                        </div>
                    )
                })}
            </div>
        </SectionShell>
    )
}
